exports = module.exports = require("../../../node_modules/.pnpm/registry.npmmirror.com+css-loader@0.28.7/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".con {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding-top: 200px;\n  padding-bottom: 50px;\n}\n.con .text {\n  font-size: 20px;\n  margin-bottom: 30px;\n}\n.con .text span {\n  font-size: 60px;\n}\n.con .img-box {\n  float: right;\n  max-width: 430px;\n}\n.con .img-box img {\n  width: 100%;\n}\n.con .right {\n  padding-left: 60px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/registry.npmmirror.com+css-loader@0.28.7/node_modules/css-loader?{"importLoaders":1}!./node_modules/.pnpm/registry.npmmirror.com+postcss-loader@2.0.8/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/.pnpm/registry.npmmirror.com+less-loader@4.1.0_less@2.7.3+webpack@3.8.1/node_modules/less-loader/dist/cjs.js!./src/pages/nomatch/index.less
// module id = 542
// module chunks = 20